<div
  #telephoneContainer
  class="_inputs-container"
  [ngClass]="{
    invalid:
      (loginDisabled &&
        phoneControl.touched &&
        phoneValidationControl.invalid) ||
      (parentFormControl.touched && parentFormControl.invalid)
  }"
>
  <div class="_deal-container">
    <div class="_before">+</div>
    <input
      type="tel"
      [formControl]="dealCodeControl"
      [matAutocomplete]="auto"
      class="input _deal-input"
    />
    <svg
      class="_after"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.27125 9.21806C7.98043 8.92725 7.50893 8.92725 7.21811 9.21806C6.9273 9.50888 6.9273 9.98038 7.21811 10.2712L11.4734 14.5265C11.7642 14.8173 12.2358 14.8173 12.5266 14.5265L16.7819 10.2712C17.0727 9.98038 17.0727 9.50888 16.7819 9.21806C16.4911 8.92725 16.0196 8.92725 15.7288 9.21806L11.998 12.9488L8.27125 9.21806Z"
        fill="#42526E"
      />
    </svg>
    <mat-autocomplete
      autoActiveFirstOption
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      panelWidth="290"
      class="_deal-list"
    >
      <mat-option
        *ngFor="let option of filteredOptions$ | async"
        [value]="option"
      >
        <span class="_country">{{ option.country }}</span>
        <span class="_code">+{{ option.code }}</span>
      </mat-option>
    </mat-autocomplete>
  </div>

  <input
    #phoneInput
    [formControl]="phoneControl"
    class="input"
    autocomplete="on"
    type="tel"
    [style.width]="'100%'"
    [readOnly]="readonly"
    (blur)="markParentAsTouched()"
    mask="000-000-0000"
    placeholder="800-555-0100"
  />
</div>
